<template>
  <van-popup v-model="show" :close-on-click-overlay="false">
    <div class="pop-container" :class="{ normal: normal, lottery: lottery }"
      v-if="popVoteInfo && Object.keys(popVoteInfo).length">
      <div class="pop-box">
        <div class="pop-title">{{ voteInfo.window_title }}</div>
        <div class="pop-des">{{ voteInfo.window_content }}</div>
        <div class="pop-btn-group">
          <van-button class="pop-btn" @click="handleRoute">{{ voteInfo.window_button }}
          </van-button>
        </div>
      </div>
      <div class="close" @click.stop="handleClosePop"></div>
    </div>
  </van-popup>
</template>



<script>
import { WebBridgeApi } from "ijsbridge";

export default {
  name: "",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    popVoteInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      show: false,
      voteInfo: {}
    }
  },
  components: {
  },
  watch: {
    showModal: {
      handler(val) {
        if (val) {
          this.show = val
        }
      },
      immediate: true
    },
    popVoteInfo: {
      handler() {
        this.voteInfo = this.popVoteInfo
      },
      immediate: true
    }
  },
  computed: {
    normal() {
      if (this.voteInfo && Object.keys(this.voteInfo).length) {
        return this.voteInfo.window_activity_business === '' ? true : false
      }
    },
    lottery() {
      if (this.voteInfo && Object.keys(this.voteInfo).length) {
        return this.voteInfo.window_activity_business === 'lottery' ? true : false
      }
    },
  },
  methods: {
    handleRoute() {
      console.log('handleRoute', this.voteInfo.window_activity_url)
      WebBridgeApi.router({
        route: 'webapp',
        params: {
          url: this.voteInfo.window_activity_url
        }
      })
      this.show = false
      this.$emit('closePopAfter')
    },
    handleClosePop() {
      this.show = false
      this.$emit('closePopAfter')
    }
  },
  created() {
  },
}
</script>

<style scoped lang="less">
.van-popup {
  background: transparent;
}

.pop-container {
  background-color: transparent;

  .pop-box {
    display: flex;
    flex-direction: column;
    padding: 1rem 0 .68rem 0;

    .pop-title {
      text-align: center;
      font-size: .62rem;
      font-weight: bold;
      background: linear-gradient(180deg, #33B5FF 0%, #4975FE 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .pop-des {
      font-size: .32rem;
      line-height: .4rem;
      color: #333;
      text-align: center;
      flex: 1;
      display: flex;
      align-items: center;
      padding: 0 1.48rem;
      width: 100%;
    }

    .pop-btn-group {
      text-align: center;
    }

    .pop-btn {
      border: none;
      font-size: .36rem;
      text-align: center;
      background: transparent;

      .van-button__text {
        font-weight: bold;
      }
    }
  }

  .close {
    width: .58rem;
    height: .58rem;
    background: url(../assets/images/icon-close-circle.png) center center/contain no-repeat;
    margin: .5rem auto 0;
  }
}

.pop-container.normal {
  .pop-box {
    width: 6.13rem;
    height: 7.24rem;
    background: url(../assets/images/bg-pop-cnt-normal.png) center center/contain no-repeat;

    .pop-title {
      margin-top: .4rem;
    }

    .pop-des {
      margin-top: .2rem;
    }

    .pop-btn {
      width: 3.43rem;
      height: 1.02rem;
      background: url(../assets/images/btn-pop-normal.png) center center/contain no-repeat;
    }
  }
}

.pop-container.lottery {
  .pop-box {
    width: 4.86rem;
    height: 5.51rem;
    background: url(../assets/images/bg-pop-cnt-lottery.png) center center/contain no-repeat;
    padding: .5rem 0 .35rem 0;

    .pop-title {
      color: #9E744C;
      background: #9E744C;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .pop-des {
      color: #9E744C;
      padding: 0 .84rem;
      margin-bottom: .75rem;
    }

    .pop-btn {
      width: 2.85rem;
      height: .75rem;
      color: #fff;
      background: url(../assets/images/btn-pop-lottery.png) center center/contain no-repeat;
    }
  }
}
</style>